"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListListGenerateButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const viem_1 = require("viem");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const setReward_json_1 = __importDefault(require("@framework/abis/json/WaitList/setReward.json"));
const constants_1 = require("@framework/constants");
const hooks_1 = require("../../../../../hooks");
const WaitListListGenerateButton = (props) => {
    const { className, waitListList: { id, contract, root }, disabled, variant, onRefreshPage, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { hasPermission } = (0, hooks_1.useSetButtonPermission)(types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE, contract?.id);
    const { mutateAsync } = (0, react_hooks_1.useMutationQuery)("/wait-list/list/generate", "POST");
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (result) => {
        return writeContractAsync({
            address: result.contract.address,
            abi: setReward_json_1.default,
            functionName: "setReward",
            args: [
                {
                    externalId: id,
                    expiresAt: 0,
                    nonce: (0, viem_1.padHex)("0x0", { size: 32 }),
                    extra: (0, viem_1.toBytes)(result.root),
                    receiver: constants_1.ZeroAddress,
                    referrer: constants_1.ZeroAddress,
                },
                result.item?.components.map(component => ({
                    tokenType: Object.values(types_1.TokenType).indexOf(component.tokenType),
                    token: component.contract.address,
                    tokenId: component.templateId || 0,
                    amount: component.amount,
                })),
            ],
        });
    });
    const handleUpload = async () => {
        await mutateAsync({ data: { listId: id } }).then(async (proof) => {
            // proof can be undefined in case of http error
            // the error is handled by useApiCall
            if (proof) {
                await metaFn(proof);
                await onRefreshPage();
            }
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.Settings, message: "form.buttons.submit", className: className, dataTestId: "WaitListListGenerateButton", disabled: disabled || !!root || contract.contractStatus !== types_1.ContractStatus.ACTIVE || !hasPermission, variant: variant }));
};
exports.WaitListListGenerateButton = WaitListListGenerateButton;
//# sourceMappingURL=index.js.map